class MatchEliminationsController {
  constructor(
    MatchesFactory,
    LeaguesFactory,
    $rootScope,
    $filter,
    $state,
    ngDialog
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    /* Load Matches dat */
    vm.$onInit = function () {
      $state.current.data.hideSidebar = true;
      vm.eliminationTypes = MatchesFactory.MATCH_ELIMINATION_TYPES;
      vm.rootScope = $rootScope;
      vm.options = [
        { id: 1, name: "ELIMINATION_INDIVIDUAL" },
        { id: 2, name: "ELIMINATION_TEAM" },
        { id: 3, name: "ELIMINATION_MIXED_TEAM" },
      ];
      vm.matchLeagues = [];
      vm.createdLeagues = {
        individual: [],
        team: [],
        mixed: [],
      };
      vm.activeOption = 0;
      vm.perTargetOptions = [1, 2, 3, 4];
      vm.roundOptions = [64, 32, 16, 8, 4, 2, 1];
      vm.startingFromTarget = 1;
      vm.perTarget = 2;
      vm.activeTargetEliminationType = 1;
      vm.activeTargetEliminationLeague = 1;
      vm.activeTargetEliminationRound = 1;
      reloadMatchData();
    };

    vm.selectOption = (option) => {
      vm.addLeague = null;
      vm.participants = null;
      vm.activeOption = option;
      vm.activeLeagueTeam = null;
      vm.activeLeagueName = null;
    };
    vm.createElimination = (leagueId, eliminationType) => {
      let entries;
      let matchLeague = vm.matchLeagues.filter((obj) => {
        return obj.league_id === leagueId;
      });
      if (
        eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.INDIVIDUAL
      ) {
        entries = matchLeague[0].entries;
      } else if (
        eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM
      ) {
        entries = matchLeague[0].teamEliminationEntries;
      } else if (
        eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM
      ) {
        entries = matchLeague[0].mixedTeamEliminationEntries;
      }
      let participants = getParticipantsFromEntries(entries);
      if (!entries || !participants) {
        return;
      }
      MatchesFactory.createElimination(
        vm.rootScope.currentMatchId,
        leagueId,
        participants,
        eliminationType
      ).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        reloadMatchData();
      });
    };
    vm.deleteElimination = (leagueId, eliminationType) => {
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate("CONFIRM_DELETE_ELIMINATION_MATCH"),
          },
        })
        .then(() => {
          MatchesFactory.deleteElimination(
            vm.rootScope.currentMatchId,
            leagueId,
            eliminationType
          ).then((response) => {
            ngDialog.open({ template: "successTemplate" });
            reloadMatchData();
          });
        });
    };
    vm.nextRoundElimination = (leagueId, eliminationType) => {
      MatchesFactory.nextRoundElimination(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType
      ).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        reloadMatchData();
      });
    };
    vm.printPDF = (leagueId, eliminationType) => {
      const tabWindowId = window.open("about:blank", "_blank");
      MatchesFactory.printsElimination(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType
      ).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };
    vm.printBoards = (leagueId, eliminationType, round) => {
      const tabWindowId = window.open("about:blank", "_blank");
      MatchesFactory.printsEliminationTargetBoards(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType,
        round.replace("1/", "")
      ).then((response) => {
        let file = new Blob([response.data], { type: "application/pdf" });
        tabWindowId.location.href = window.URL.createObjectURL(file);
      });
    };
    vm.getDetails = (leagueId, eliminationType, appendLeagueName) => {
      vm.teamLeagueGridOptions.data = [];
      MatchesFactory.details(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType
      ).then((response) => {
        if (appendLeagueName) {
          vm.activeLeagueName =
            response.data[0].leagueName + " - " + appendLeagueName;
        } else {
          vm.activeLeagueName = response.data[0].leagueName;
        }
        if (eliminationType === MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM) {
          vm.teamLeagueGridOptions.data = response.data;
          vm.mixedLeague = 0;
        } else {
          vm.mixedTeamLeagueGridOptions.data = response.data;
          vm.mixedLeague = 1;
        }
      });
    };
    vm.updateTeamLeaguePlayers = () => {
      let leagueId = vm.activeLeagueTeam.league_id;
      let teamId = vm.activeLeagueTeam.team_id;
      let eliminationType = MatchesFactory.MATCH_ELIMINATION_TYPES.TEAM;
      let players = [];
      players.push(vm.activeLeagueTeam.playerOne.player_id);
      players.push(vm.activeLeagueTeam.playerTwo.player_id);
      players.push(vm.activeLeagueTeam.playerThree.player_id);
      MatchesFactory.updateElimination(
        vm.rootScope.currentMatchId,
        leagueId,
        teamId,
        eliminationType,
        players
      ).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        reloadTeamLeagueData(leagueId, eliminationType);
      });
    };
    vm.updateMixedTeamLeaguePlayers = () => {
      let leagueId = vm.activeLeagueTeam.league_1_id;
      let teamId = vm.activeLeagueTeam.team_id;
      let eliminationType = MatchesFactory.MATCH_ELIMINATION_TYPES.MIXED_TEAM;
      let players = [];
      players.push(vm.activeLeagueTeam.playerOne.player_id);
      players.push(vm.activeLeagueTeam.playerTwo.player_id);
      MatchesFactory.updateElimination(
        vm.rootScope.currentMatchId,
        leagueId,
        teamId,
        eliminationType,
        players
      ).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        reloadMixedTeamLeagueData(leagueId, eliminationType);
      });
    };
    vm.produceTargets = () => {
      MatchesFactory.eliminationProduceTargets(
        vm.rootScope.currentMatchId,
        vm.activeTargetEliminationLeague.league_id,
        vm.activeTargetEliminationType,
        vm.activeTargetEliminationRound,
        vm.perTarget,
        vm.startingFromTarget
      ).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        reloadMatchData();
      });
    };

    vm.setActiveEliminationTargetsProduce = (matchLeague, type) => {
      vm.activeTargetEliminationType = type;
      vm.activeTargetEliminationLeague = matchLeague;
    };

    /* INDIVIDUAL */
    vm.individualGridOptions = {
      enableSorting: false,
      enablePaginationControls: false,
      enableColumnMenus: false,
      enableFiltering: false,
      columnDefs: [
        {
          field: "leagueName",
          enableFiltering: false,
          name: $translate("LEAGUE_NAME"),
        },
        {
          field: "entries",
          enableFiltering: false,
          name: $translate("ENTRIES"),
          width: "90",
        },
        {
          field: "startingIndividualRound",
          enableFiltering: false,
          name: $translate("STARTING_ROUND"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'ng-if="row.entity.olympic_players > 0"' +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm accent">{{row.entity.startingIndividualRound}}</button>' +
            "</div>",
          width: "80",
        },
        {
          field: "currentIndividualRound",
          enableFiltering: false,
          name: $translate("CURRENT_ROUND"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'ng-if="row.entity.olympic_players > 0"' +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm indigo">{{row.entity.currentIndividualRound}}</button>' +
            "</div>",
          width: "120",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-success" translate ' +
            'ng-if="!row.entity.olympic_players"' +
            'ng-click="grid.appScope.vm.createElimination(row.entity.league_id,1)">CREATE</button> ' +
            '<button class="btn btn-sm btn-info" translate ' +
            'ng-if="row.entity.olympic_players > 0"' +
            'ng-click="grid.appScope.vm.nextRoundElimination(row.entity.league_id,1)">NEXT_ROUND</button> ' +
            '<button class="btn btn-sm btn-warning" translate ' +
            'ng-if="row.entity.olympic_players > 0"' +
            'ng-click="grid.appScope.vm.printPDF(row.entity.league_id,1)">PRINT_PDF</button> ' +
            '<button class="btn btn-sm btn-danger" translate ' +
            'ng-if="row.entity.olympic_players > 0"' +
            'ng-click="grid.appScope.vm.deleteElimination(row.entity.league_id,1)">DELETE</button> ' +
            '<button class="btn btn-sm accent" translate ' +
            'ng-if="row.entity.olympic_players > 0"' +
            'ng-click="grid.appScope.vm.printBoards(row.entity.league_id,1, row.entity.currentIndividualRound)">BOARDS</button> ' +
            "<button " +
            'ng-if="row.entity.olympic_players > 0"' +
            'class="btn btn-sm info" ' +
            'data-toggle="modal" ' +
            "translate " +
            'ng-click="grid.appScope.vm.setActiveEliminationTargetsProduce(row.entity, 1)" ' +
            'data-target="#produceTargetsModal">TARGETS</button> ' +
            "</div>" +
            "</div>",
          width: "410",
        },
      ],
    };

    /* TEAM */
    vm.teamGridOptions = {
      enableSorting: false,
      enablePaginationControls: false,
      enableColumnMenus: false,
      enableFiltering: false,
      columnDefs: [
        {
          field: "leagueName",
          enableFiltering: false,
          name: $translate("LEAGUE_NAME"),
        },
        {
          field: "teamEliminationEntries",
          enableFiltering: false,
          name: $translate("ENTRIES"),
          width: "90",
        },
        {
          field: "startingTeamRound",
          enableFiltering: false,
          name: $translate("STARTING_ROUND"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'ng-if="row.entity.olympic_teams > 0"' +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm accent">{{row.entity.startingTeamRound}}</button>' +
            "</div>",
          width: "80",
        },
        {
          field: "currentTeamRound",
          enableFiltering: false,
          name: $translate("CURRENT_ROUND"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'ng-if="row.entity.olympic_teams > 0"' +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm indigo">{{row.entity.currentTeamRound}}</button>' +
            "</div>",
          width: "120",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-success" translate ' +
            'ng-if="!row.entity.olympic_teams"' +
            'ng-click="grid.appScope.vm.createElimination(row.entity.league_id,2)">CREATE</button> ' +
            '<button class="btn btn-sm btn-info" translate ' +
            'ng-if="row.entity.olympic_teams > 0"' +
            'ng-click="grid.appScope.vm.nextRoundElimination(row.entity.league_id,2)">NEXT_ROUND</button> ' +
            '<button class="btn btn-sm btn-warning" translate ' +
            'ng-if="row.entity.olympic_teams > 0"' +
            'ng-click="grid.appScope.vm.printPDF(row.entity.league_id,2)">PRINT_PDF</button> ' +
            '<button class="btn btn-sm indigo" translate ' +
            'ng-if="row.entity.olympic_teams > 0 && grid.appScope.vm.rootScope.user.isPremium()"' +
            'ng-click="grid.appScope.vm.getDetails(row.entity.league_id,2)">PLAYERS</button> ' +
            '<button class="btn btn-sm btn-danger" translate ' +
            'ng-if="row.entity.olympic_teams > 0"' +
            'ng-click="grid.appScope.vm.deleteElimination(row.entity.league_id,2)">DELETE</button> ' +
            '<button class="btn btn-sm accent" translate ' +
            'ng-if="row.entity.olympic_teams > 0"' +
            'ng-click="grid.appScope.vm.printBoards(row.entity.league_id,2, row.entity.currentTeamRound)">BOARDS</button> ' +
            "</div>" +
            "</div>",
          width: "440",
        },
      ],
    };
    vm.teamLeagueGridOptions = {
      enableSorting: false,
      enablePaginationControls: false,
      enableColumnMenus: false,
      enableFiltering: false,
      columnDefs: [
        {
          field: "teamName",
          enableFiltering: false,
          name: $translate("TEAM_NAME"),
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents">{{row.entity.team.teamName}}</div>',
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm info" ' +
            'data-toggle="modal" ' +
            "translate " +
            'ng-click="grid.appScope.vm.activeLeagueTeam = row.entity" ' +
            'data-target="#changeTeamLeaguePlayersModal">EDIT</button></div>',
          width: "340",
        },
      ],
    };

    /* MIXED TEAM */
    vm.mixedTeamGridOptions = {
      enableSorting: false,
      enablePaginationControls: false,
      enableColumnMenus: false,
      enableFiltering: false,
      columnDefs: [
        {
          field: "leagueName",
          enableFiltering: false,
          name: $translate("LEAGUE_NAME"),
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents p-t-5">{{row.entity.leagueName}} - {{row.entity.mixedLeagueNameAppendName}}</div>',
        },
        {
          field: "mixedTeamEliminationEntries",
          enableFiltering: false,
          name: "Entries",
          width: "90",
        },
        {
          field: "startingMixedTeamRound",
          enableFiltering: false,
          name: $translate("STARTING_ROUND"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'ng-if="row.entity.olympic_mixed > 0"' +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm accent">{{row.entity.startingMixedTeamRound}}</button>' +
            "</div>",
          width: "80",
        },
        {
          field: "currentMixedTeamRound",
          enableFiltering: false,
          name: $translate("CURRENT_ROUND"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'ng-if="row.entity.olympic_mixed > 0"' +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm indigo">{{row.entity.currentMixedTeamRound}}</button>' +
            "</div>",
          width: "120",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-success" translate ' +
            'ng-if="!row.entity.olympic_mixed"' +
            'ng-click="grid.appScope.vm.createElimination(row.entity.league_id,3)">CREATE</button> ' +
            '<button class="btn btn-sm btn-info" translate ' +
            'ng-if="row.entity.olympic_mixed > 0"' +
            'ng-click="grid.appScope.vm.nextRoundElimination(row.entity.league_id,3)">NEXT_ROUND</button> ' +
            '<button class="btn btn-sm btn-warning" translate ' +
            'ng-if="row.entity.olympic_mixed > 0"' +
            'ng-click="grid.appScope.vm.printPDF(row.entity.league_id,3)">PRINT_PDF</button> ' +
            '<button class="btn btn-sm indigo" translate ' +
            'ng-if="row.entity.olympic_mixed > 0 && grid.appScope.vm.rootScope.user.isPremium()"' +
            'ng-click="grid.appScope.vm.getDetails(row.entity.league_id,3,row.entity.mixedLeagueNameAppendName)">PLAYERS</button> ' +
            '<button class="btn btn-sm btn-danger" translate ' +
            'ng-if="row.entity.olympic_mixed > 0"' +
            'ng-click="grid.appScope.vm.deleteElimination(row.entity.league_id,3)">DELETE</button> ' +
            '<button class="btn btn-sm accent" translate ' +
            'ng-if="row.entity.olympic_mixed > 0"' +
            'ng-click="grid.appScope.vm.printBoards(row.entity.league_id,3, row.entity.currentMixedTeamRound)">BOARDS</button> ' +
            "</div>" +
            "</div>",
          width: "440",
        },
      ],
    };
    vm.mixedTeamLeagueGridOptions = {
      enableSorting: false,
      enablePaginationControls: false,
      enableColumnMenus: false,
      enableFiltering: false,
      columnDefs: [
        {
          field: "teamName",
          enableFiltering: false,
          name: $translate("TEAM_NAME"),
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents">{{row.entity.team.teamName}}</div>',
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm info" ' +
            'data-toggle="modal" ' +
            "translate " +
            'ng-click="grid.appScope.vm.activeLeagueTeam = row.entity" ' +
            'data-target="#changeTeamLeaguePlayersModal">EDIT</button></div>',
          width: "340",
        },
      ],
    };

    function reloadMatchData() {
      vm.matchLeagues = [];
      vm.createdLeagues = {
        individual: [],
        team: [],
        mixed: [],
      };
      MatchesFactory.getOne(vm.rootScope.currentMatchId, {
        include: "matchLeagues",
      }).then((response) => {
        let includedMixedLeagues = [];
        vm.matchLeagues = response.data.matchLeagues;
        vm.matchOlympicTeamDetails = response.data.matchOlympicTeamDetails;
        Object.entries(vm.matchLeagues).forEach((entry) => {
          let value = entry[1];
          /* INDIVIDUAL */
          if (value.olympic_players || value.entries > 3) {
            vm.createdLeagues.individual.push(value);
          }
          /* TEAM */
          if (value.olympic_teams || value.teamEliminationEntries > 3) {
            vm.createdLeagues.team.push(value);
          }
          /* MIXED TEAM */
          if (value.olympic_mixed || value.mixedTeamEliminationEntries > 3) {
            if (!includedMixedLeagues.includes(value.league_id)) {
              vm.createdLeagues.mixed.push(value);
              includedMixedLeagues.push(value.league_id);
              includedMixedLeagues.push(value.league.mixed_league_id);
            }
          }
          vm.individualGridOptions.data = vm.createdLeagues.individual;
          vm.teamGridOptions.data = vm.createdLeagues.team;
          vm.mixedTeamGridOptions.data = vm.createdLeagues.mixed;
        });
      });
    }

    function reloadTeamLeagueData(leagueId, eliminationType) {
      MatchesFactory.details(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType
      ).then((response) => {
        vm.teamLeagueGridOptions.data = response.data;
      });
    }

    function reloadMixedTeamLeagueData(leagueId, eliminationType) {
      MatchesFactory.details(
        vm.rootScope.currentMatchId,
        leagueId,
        eliminationType
      ).then((response) => {
        vm.mixedTeamLeagueGridOptions.data = response.data;
      });
    }

    function getParticipantsFromEntries(entries) {
      let matchType = vm.rootScope.currentMatch.match_type;
      if (entries < 4) {
        return false;
      } else if (entries === 4) {
        return 4;
      } else if (entries <= 8) {
        return 8;
      } else if (entries <= 16) {
        return 16;
      } else if (
        entries <= 32 ||
        matchType === MatchesFactory.MATCH_TYPES.INDOOR
      ) {
        return 32;
      } else if (entries <= 64) {
        return 32;
      }
    }
  }
}

export default MatchEliminationsController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchEliminations/matchEliminations.controller.js